import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  console.log('FRONTEND_BUILD_TAG', FRONTEND_BUILD_TAG);
  console.log('FRONTEND_BUILD_SHA', FRONTEND_BUILD_SHA);
  const versionText = [FRONTEND_BUILD_TAG, FRONTEND_BUILD_SHA ? FRONTEND_BUILD_SHA.slice(0, 7) : '']
    .filter(Boolean)
    .join(' ');
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${new Date().getFullYear()} 青岛青武材料科技有限公司${versionText ? ` · ${versionText}` : ''}`}
      links={[
        {
          key: 'Ant Design Pro',
          title: '青武业务管理系统',
          href: 'https://app.qingwu.tech',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://github.com/qingwu-tech/qingwu-frontend',
          blankTarget: true,
        },
        {
          key: '操作手册',
          title: '操作手册',
          href: '/manual/index.html',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
